import { render, staticRenderFns } from "./DamageItem.vue?vue&type=template&id=2169ba54&"
import script from "./DamageItem.vue?vue&type=script&lang=js&"
export * from "./DamageItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports